/* eslint-disable no-console */

import { useCallback, useState } from 'react';
export default function useValueProp(props) {
  const controlled = Reflect.has(props, 'value');
  const {
    value: _value,
    onChange,
    defaultValue
  } = props;
  const [value, setValue] = useState(defaultValue);
  const handleChange = useCallback(e => {
    const nextValue = e.target.value;
    if (controlled && !onChange) {
      console.warn('OnChange event handler is required for controlled input');
      return;
    }
    onChange == null ? void 0 : onChange(nextValue, e);
    if (!controlled) {
      setValue(nextValue);
    }
  }, [onChange, controlled]);
  return {
    onChange: handleChange,
    value: (controlled ? _value : value) || ''
  };
}